import './Breadcrumbs.scss';

import { Fragment, useMemo } from 'react';
import { Link, useParams } from 'react-router';

import { FAQ_ROUTES } from '@/components/Shared/routes/routes';
import { ArrowRightOutlined } from '@/media/antd-icons';
import { useAppSelector } from '@/store';
import { type TMenuItem } from '@/types/app';

function findPathByUuid(menu: TMenuItem[], uuid: string): TMenuItem[] {
  if (!uuid) return [];
  for (const item of menu) {
    if (item.id === uuid) {
      return [item];
    }
    if (item.children && Array.isArray(item.children)) {
      const childPath = findPathByUuid(item.children, uuid);
      if (childPath.length) {
        return [item, ...childPath];
      }
    }
  }
  return [];
}

const FaqBreadcrumbs: React.FC = () => {
  const { faqMenu } = useAppSelector((state) => state.userInfo);

  const { uuid } = useParams();

  const breadcrumbPath: TMenuItem[] = useMemo(() => {
    const rootPathItem: TMenuItem = {
      id: 'home',
      label: 'Главная',
      link: FAQ_ROUTES.root
    };
    if (!uuid) return [rootPathItem];

    const path = findPathByUuid(faqMenu, uuid);
    return [rootPathItem, ...path];
  }, [faqMenu, uuid]);

  if (breadcrumbPath.length <= 1) {
    return null;
  }
  return (
    <div className="faq-breadcrumbs">
      {breadcrumbPath.map((item, index) => (
        <Fragment key={item.id}>
          {item.externalLink ? (
            <a
              href={item.externalLink}
              target="_blank"
              className="faq-breadcrumbs__link"
            >
              {item.label}
              {!!item.extension && (
                <span className="faq-breadcrumbs__extension">
                  {item.extension}
                </span>
              )}
            </a>
          ) : item.link && item.id !== uuid ? (
            <Link className="faq-breadcrumbs__link" to={item.link}>
              {item.label}
            </Link>
          ) : (
            <span
              className={`faq-breadcrumbs__non-link ${item.id === uuid ? 'faq-breadcrumbs__non-link--active' : ''}`}
            >
              {item.label}
              {!!item.extension && (
                <span className="faq-breadcrumbs__extension">
                  {item.extension}
                </span>
              )}
            </span>
          )}
          {index < breadcrumbPath.length - 1 && (
            <span className="faq-breadcrumbs__separator">
              <ArrowRightOutlined />
            </span>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default FaqBreadcrumbs;
